var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "store" }, [
      _c("div", { staticClass: "banxin" }, [
        _c("div", { staticStyle: { background: "#fff" } }, [
          _c("div", { staticClass: "dingbu" }, [
            _c("div", { staticClass: "toutou warp" }, [
              _c("div", { staticStyle: { height: "79px" } }, [
                _c("img", {
                  staticClass: "logo",
                  attrs: {
                    src: require("../../assets/images/dlogo.png"),
                    alt: ""
                  },
                  on: { click: _vm.gotoIndex }
                })
              ]),
              _vm._v(" "),
              _c("div", {
                staticStyle: {
                  width: "2px",
                  height: "40px",
                  "background-color": "#eeeff1",
                  margin: "10px 20px",
                  "margin-top": "38px"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "menu" }, [
                _c(
                  "div",
                  {
                    staticClass: "menu-flag",
                    on: {
                      mouseout: function($event) {
                        _vm.showClassify = false
                      },
                      mouseover: function($event) {
                        _vm.$route.name !== "index"
                          ? (_vm.showClassify = true)
                          : null
                      }
                    }
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "el-icon-arrow-right",
                      class: "" + (_vm.showClassify ? "turnDown" : "turnDown2"),
                      staticStyle: { "margin-left": "4px", "margin-top": "2px" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showClassify,
                            expression: "showClassify"
                          }
                        ],
                        staticClass: "classify-outer",
                        class: "" + (_vm.showClassify ? "showClassify" : ""),
                        staticStyle: {
                          "background-color": "#fff",
                          "z-index": "999",
                          "margin-top": "-12px"
                        }
                      },
                      [
                        _c("cere-classification", {
                          staticStyle: { height: "auto !important" },
                          attrs: {
                            componentContent:
                              _vm.componentContent[0].componentContent
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "searchright" }, [
                _c(
                  "div",
                  {
                    staticStyle: { display: "flex", "justify-content": "right" }
                  },
                  [
                    _c("el-input", {
                      staticClass: "shuru",
                      attrs: {
                        placeholder: "请输入内容",
                        "prefix-icon": "el-icon-search"
                      },
                      model: {
                        value: _vm.searchFrom.search,
                        callback: function($$v) {
                          _vm.$set(_vm.searchFrom, "search", $$v)
                        },
                        expression: "searchFrom.search"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "quanzhan" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "qzBtn",
                            attrs: { type: "primary" },
                            on: { click: _vm.getAllProduct }
                          },
                          [_vm._v("搜全站\n                  ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "bendain" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "bdBtn",
                        attrs: { type: "info" },
                        on: { click: _vm.getInfoProduct }
                      },
                      [_vm._v("搜本店")]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "shop" }, [
              _c(
                "div",
                {
                  staticClass: "warp",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    padding: "30px 0 5px",
                    position: "relative"
                  }
                },
                [
                  _c("div", { staticClass: "shop1" }, [
                    _c("div", { staticClass: "shopInfo-box" }, [
                      _c("div", { staticClass: "shopHeard" }, [
                        _c("div", [
                          _c("h2", { staticClass: "shopName" }, [
                            _vm._v(_vm._s(_vm.shopName))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "guanzhu",
                            style:
                              _vm.collectData.ifCollect === 0
                                ? ""
                                : "background-color: rgba(255, 71, 71, 1);color: #fff;",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.collect.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                      " +
                                _vm._s(
                                  _vm.collectData.ifCollect === 0
                                    ? "关注"
                                    : "已关注"
                                ) +
                                "\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "shopCode",
                            staticStyle: {
                              "margin-left": "20px",
                              cursor: "pointer",
                              position: "relative"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                width: "30px",
                                "margin-top": "8px"
                              },
                              attrs: {
                                src: require("@/assets/images/shopCode.png"),
                                alt: ""
                              },
                              on: {
                                mouseout: function($event) {
                                  _vm.shopCode = false
                                },
                                mouseover: function($event) {
                                  _vm.shopCode = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.shopCode == true
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      top: "0px",
                                      left: "50px",
                                      "z-index": "1000",
                                      background: "#ffffff",
                                      width: "250px",
                                      height: "250px",
                                      "text-align": "center",
                                      padding: "10px",
                                      "box-shadow": "0px 5px 10px 0px",
                                      "border-radius": "4px"
                                    }
                                  },
                                  [
                                    _c("vue-qr", {
                                      attrs: {
                                        size: 200,
                                        margin: 0,
                                        "auto-color": true,
                                        "dot-scale": 1,
                                        text: _vm.appSrc
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          "text-align": "center",
                                          "margin-top": "5px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                          店铺二维码（手机APP扫码）\n                        "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "information" }, [
                        _c("img", {
                          staticClass: "renzheng",
                          attrs: {
                            src: require("../../assets/images/renzheng.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "dizhi" }, [
                          _c("i", {
                            staticClass: "icon-positioning",
                            staticStyle: {
                              color: "#fb7600",
                              "font-size": "20px",
                              "margin-right": "5px"
                            }
                          }),
                          _vm._v(
                            "\n                      " +
                              _vm._s(this.adressForm.shopAdress)
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "550px",
                        "font-size": "24px",
                        "font-weight": "bold",
                        color: "#864c17",
                        position: "absolute",
                        top: "50px",
                        left: "45%"
                      }
                    },
                    [
                      _vm._v(
                        "\n                严选优质商品  直供源价好货\n              "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-right": "50px",
                        "text-align": "right"
                      }
                    },
                    [
                      _c("div", { staticClass: "block11" }, [
                        _c("img", {
                          staticClass: "img1",
                          attrs: {
                            referrerpolicy: "no-referrer",
                            src: require("../../assets/images/tel.png")
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-top": "5px",
                              "margin-left": "10px",
                              "font-size": "18px"
                            }
                          },
                          [
                            _c("span", { staticClass: "info34" }, [
                              _vm._v("店铺服务热线:")
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.formData.chargePersonPhone))
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "el-tab-box" },
              [
                _c(
                  "el-tabs",
                  {
                    staticClass: "tabs warp",
                    on: { "tab-click": _vm.handleClick },
                    model: {
                      value: _vm.activeName,
                      callback: function($$v) {
                        _vm.activeName = $$v
                      },
                      expression: "activeName"
                    }
                  },
                  [
                    _c("el-tab-pane", {
                      attrs: { label: "首页", name: "index" }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-tab-pane",
                      {
                        staticStyle: { position: "relative" },
                        attrs: { label: "产品分类", name: "shopClassifyList" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "inline-block",
                              height: "100%"
                            },
                            attrs: { slot: "label" },
                            on: {
                              mouseover: function($event) {
                                _vm.showMenu = true
                              },
                              mouseleave: function($event) {
                                _vm.showMenu = false
                              }
                            },
                            slot: "label"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "150px",
                                  height: "100%",
                                  "margin-left": "-15px",
                                  padding: "0 -20px"
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.getClassifyProduct("")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    产品分类\n                    "
                                ),
                                _c("i", {
                                  class: _vm.showMenu
                                    ? "el-icon-caret-bottom selectMenu"
                                    : "el-icon-caret-bottom"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _vm.showMenu
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "ShopMenu",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [
                                    _c("div", { staticClass: "menuall" }, [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "border-right": "1px solid #e5e5e5"
                                          }
                                        },
                                        _vm._l(_vm.shopClassifyList, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "menuItem",
                                              on: {
                                                mouseover: function($event) {
                                                  return _vm.getChildren(item)
                                                },
                                                mouseleave: _vm.clianChildren,
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.getClassifyProduct(
                                                    item.classifyId
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(item.classifyName)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("i", {
                                                class: _vm.showMenu2
                                                  ? "el-icon-arrow-right selectMenu2"
                                                  : "el-icon-arrow-right",
                                                staticStyle: {
                                                  "margin-left": "10px"
                                                }
                                              })
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "background-color": "#fff",
                                            color: "#000"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "hoverBox" },
                                            _vm._l(
                                              _vm.menuChildren.childs,
                                              function(subItem, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "dl"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "dt",
                                                        staticStyle: {
                                                          cursor: "pointer"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.getClassifyProduct(
                                                                  subItem.classifyId
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                subItem.classifyName
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      { staticClass: "dd" },
                                                      _vm._l(
                                                        subItem.childs,
                                                        function(
                                                          threeItem,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "a",
                                                            {
                                                              key: index,
                                                              staticClass:
                                                                "a-link"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.getClassifyProduct(
                                                                        threeItem.classifyId
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      threeItem.classifyName
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-tab-pane", {
                      attrs: { label: "公司档案", name: "dossier" }
                    }),
                    _vm._v(" "),
                    _c("el-tab-pane", {
                      attrs: { label: "联系我们", name: "contact" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "warp" }, [
          _vm.isIndex
            ? _c(
                "div",
                [
                  _vm.shopId
                    ? _c("shopHome", {
                        attrs: { terminal: 4, typeId: 3, shopId: _vm.shopId }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm.isShopClassifyList
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _c(
                      "el-breadcrumb",
                      {
                        staticStyle: { "font-size": "16px" },
                        attrs: { "separator-class": "el-icon-arrow-right" }
                      },
                      _vm._l(_vm.breadList, function(items, index) {
                        return _c("el-breadcrumb-item", { key: index }, [
                          _c(
                            "span",
                            {
                              staticClass: "bread",
                              on: {
                                click: function($event) {
                                  return _vm.getClassifyProduct(
                                    items.classifyId
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(items.classifyName))]
                          )
                        ])
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _vm.isClssfiy
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              background: "#ffffff",
                              "margin-bottom": "30px",
                              "margin-top": "20px"
                            }
                          },
                          [
                            _c("div", { staticClass: "classify" }, [
                              _c("div", { staticClass: "xiangguan" }, [
                                _vm._v("筛选")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fontB",
                                  class: _vm.sxIndex == "4" ? "active" : "",
                                  staticStyle: { "margin-right": "30px" },
                                  on: { click: _vm.tuijianProduct }
                                },
                                [
                                  _vm._v(
                                    "\n                  推荐\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fontB",
                                  class: _vm.sxIndex == "5" ? "active" : "",
                                  on: { click: _vm.shangxinProduct }
                                },
                                [
                                  _vm._v(
                                    "\n                  上新\n                "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "classify" }, [
                              _c("div", { staticClass: "xiangguan" }, [
                                _vm._v("排序")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "default fontB",
                                  class: _vm.index == "1" ? "active" : "",
                                  on: {
                                    click: function($event) {
                                      return _vm.defaultSort()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  默认\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "prices fontB",
                                  class: _vm.index == "2" ? "active" : "",
                                  staticStyle: {
                                    display: "flex !important",
                                    "justify-content": "left !important"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.priceSort()
                                    }
                                  }
                                },
                                [
                                  _c("span", [_vm._v("价格")]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "arr" }, [
                                    _c("div", {
                                      staticClass: "up",
                                      class: _vm.type == 1 ? "low" : ""
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "down",
                                      class: _vm.type == 2 ? "high" : ""
                                    })
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "sales fontB",
                                  class: _vm.index == "3" ? "active" : "",
                                  on: {
                                    click: function($event) {
                                      return _vm.salesSort()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  销量\n                  "
                                  ),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.index !== "3",
                                        expression: "index !== '3'"
                                      }
                                    ],
                                    attrs: {
                                      src: require("../../../static/image/reduce@2x.png"),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.index == "3" && _vm.volume == 1,
                                        expression:
                                          "index == '3' && volume == 1"
                                      }
                                    ],
                                    attrs: {
                                      src: require("../../../static/image/reduce2@2x.png"),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.index == "3" && _vm.volume == 2,
                                        expression:
                                          "index == '3' && volume == 2"
                                      }
                                    ],
                                    attrs: {
                                      src: require("../../../static/image/reduce1@2x.png"),
                                      alt: ""
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "priceBox" }, [
                                _c("div", { staticClass: "pri fontB" }, [
                                  _vm._v("价格")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "min" }, [
                                  _vm._v("\n                    ¥"),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.minMoney,
                                        expression: "minMoney"
                                      }
                                    ],
                                    attrs: { type: "number" },
                                    domProps: { value: _vm.minMoney },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.minMoney = $event.target.value
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { margin: "0 10px" } },
                                  [_vm._v("-")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "max" }, [
                                  _vm._v("\n                    ¥"),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.maxMoney,
                                        expression: "maxMoney"
                                      }
                                    ],
                                    attrs: { type: "number" },
                                    domProps: { value: _vm.maxMoney },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.maxMoney = $event.target.value
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn",
                                    on: { click: _vm.priceSearch }
                                  },
                                  [_vm._v("确定")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "clear",
                                    on: { click: _vm.clearMoney }
                                  },
                                  [_vm._v("清空")]
                                )
                              ])
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _vm.noProduct == false
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                background: "#ffffff",
                                "padding-bottom": "20px"
                              }
                            },
                            [
                              _c("ProductList", {
                                attrs: { productList: _vm.productList }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {},
                                [
                                  _vm.productList.length > 0 ||
                                  _vm.storeList.length > 0
                                    ? _c("el-pagination", {
                                        attrs: {
                                          "current-page": _vm.page,
                                          "page-size": _vm.pageSize,
                                          background: "",
                                          layout: "prev, pager, next",
                                          total: _vm.total
                                        },
                                        on: {
                                          "current-change":
                                            _vm.handleCurrentChange
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c("div", { staticClass: "noproduct" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../../static/image/nothing@2x.png"),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "fs20 font-color-999" }, [
                              _vm._v("该分类没有商品～")
                            ])
                          ])
                    ])
                  ],
                  1
                )
              ])
            : _vm.isContact
            ? _c("div", [_c("contact")], 1)
            : _vm.isDossier
            ? _c("div", [_c("dossier")], 1)
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "z-index": "1000" } }, [
      _c("span", [_vm._v("商品分类")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-3fb1a7fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3fb1a7fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/store/index.vue
// module id = null
// module chunks = 